var map = {
	"./afastamento.svg": "./static/icones/afastamento.svg?raw",
	"./alerta.svg": "./static/icones/alerta.svg?raw",
	"./ativo.svg": "./static/icones/ativo.svg?raw",
	"./avatar-login.svg": "./static/icones/avatar-login.svg?raw",
	"./avatar.svg": "./static/icones/avatar.svg?raw",
	"./aviao.svg": "./static/icones/aviao.svg?raw",
	"./aviso.svg": "./static/icones/aviso.svg?raw",
	"./bi-bank2.svg": "./static/icones/bi-bank2.svg?raw",
	"./bi-receipt.svg": "./static/icones/bi-receipt.svg?raw",
	"./bv-logo-5cd49411d28021000c09e013.svg": "./static/icones/bv-logo-5cd49411d28021000c09e013.svg?raw",
	"./cadeado.svg": "./static/icones/cadeado.svg?raw",
	"./caixaVazia.svg": "./static/icones/caixaVazia.svg?raw",
	"./calendario-nenhum-dia.svg": "./static/icones/calendario-nenhum-dia.svg?raw",
	"./calendario.svg": "./static/icones/calendario.svg?raw",
	"./cancelado.svg": "./static/icones/cancelado.svg?raw",
	"./celular.svg": "./static/icones/celular.svg?raw",
	"./certo.svg": "./static/icones/certo.svg?raw",
	"./chave.svg": "./static/icones/chave.svg?raw",
	"./comprimir.svg": "./static/icones/comprimir.svg?raw",
	"./dispensa.svg": "./static/icones/dispensa.svg?raw",
	"./documento-download.svg": "./static/icones/documento-download.svg?raw",
	"./documento.svg": "./static/icones/documento.svg?raw",
	"./download.svg": "./static/icones/download.svg?raw",
	"./emojiTriste.svg": "./static/icones/emojiTriste.svg?raw",
	"./empresa-white-label-logo-5cd49411d28021000c09e013.svg": "./static/icones/empresa-white-label-logo-5cd49411d28021000c09e013.svg?raw",
	"./entrar.svg": "./static/icones/entrar.svg?raw",
	"./errado.svg": "./static/icones/errado.svg?raw",
	"./erro-preenchido.svg": "./static/icones/erro-preenchido.svg?raw",
	"./erro.svg": "./static/icones/erro.svg?raw",
	"./erro_informacao.svg": "./static/icones/erro_informacao.svg?raw",
	"./erro_linha_sem_borda.svg": "./static/icones/erro_linha_sem_borda.svg?raw",
	"./facebook.svg": "./static/icones/facebook.svg?raw",
	"./falhou.svg": "./static/icones/falhou.svg?raw",
	"./feriado.svg": "./static/icones/feriado.svg?raw",
	"./ferias.svg": "./static/icones/ferias.svg?raw",
	"./folga.svg": "./static/icones/folga.svg?raw",
	"./folha.svg": "./static/icones/folha.svg?raw",
	"./grafico-chapado.svg": "./static/icones/grafico-chapado.svg?raw",
	"./grafico.svg": "./static/icones/grafico.svg?raw",
	"./historico.svg": "./static/icones/historico.svg?raw",
	"./horas_extras.svg": "./static/icones/horas_extras.svg?raw",
	"./icone-alterar.svg": "./static/icones/icone-alterar.svg?raw",
	"./icone-biometria-facial.svg": "./static/icones/icone-biometria-facial.svg?raw",
	"./icone-borda.svg": "./static/icones/icone-borda.svg?raw",
	"./icone-camera-proibido.svg": "./static/icones/icone-camera-proibido.svg?raw",
	"./icone-celebrar-pontotel-inline.svg": "./static/icones/icone-celebrar-pontotel-inline.svg?raw",
	"./icone-celebrar-pontotel.svg": "./static/icones/icone-celebrar-pontotel.svg?raw",
	"./icone-email.svg": "./static/icones/icone-email.svg?raw",
	"./icone-fechar.svg": "./static/icones/icone-fechar.svg?raw",
	"./icone-humano-linha.svg": "./static/icones/icone-humano-linha.svg?raw",
	"./icone-humano-quadrado.svg": "./static/icones/icone-humano-quadrado.svg?raw",
	"./icone-humano.svg": "./static/icones/icone-humano.svg?raw",
	"./icone-interrogacao.svg": "./static/icones/icone-interrogacao.svg?raw",
	"./icone-lupa-preenchido.svg": "./static/icones/icone-lupa-preenchido.svg?raw",
	"./icone-mapa-enquadrar.svg": "./static/icones/icone-mapa-enquadrar.svg?raw",
	"./icone-mapa-mais.svg": "./static/icones/icone-mapa-mais.svg?raw",
	"./icone-mapa-marcador.svg": "./static/icones/icone-mapa-marcador.svg?raw",
	"./icone-mapa-menos.svg": "./static/icones/icone-mapa-menos.svg?raw",
	"./icone-seta-esquerda.svg": "./static/icones/icone-seta-esquerda.svg?raw",
	"./icone-seta-redirecionamento.svg": "./static/icones/icone-seta-redirecionamento.svg?raw",
	"./icone-setas-circulares.svg": "./static/icones/icone-setas-circulares.svg?raw",
	"./icone-trabalho.svg": "./static/icones/icone-trabalho.svg?raw",
	"./icone-usuario-retrato.svg": "./static/icones/icone-usuario-retrato.svg?raw",
	"./icone_draggable.svg": "./static/icones/icone_draggable.svg?raw",
	"./icone_lista.svg": "./static/icones/icone_lista.svg?raw",
	"./icone_pizza.svg": "./static/icones/icone_pizza.svg?raw",
	"./icone_trabalhando.svg": "./static/icones/icone_trabalhando.svg?raw",
	"./identificador-chevron.svg": "./static/icones/identificador-chevron.svg?raw",
	"./inativo.svg": "./static/icones/inativo.svg?raw",
	"./indicar.svg": "./static/icones/indicar.svg?raw",
	"./informativo.svg": "./static/icones/informativo.svg?raw",
	"./instagram.svg": "./static/icones/instagram.svg?raw",
	"./inteligencia-artificial.svg": "./static/icones/inteligencia-artificial.svg?raw",
	"./joinha.svg": "./static/icones/joinha.svg?raw",
	"./lapis.svg": "./static/icones/lapis.svg?raw",
	"./linkedin.svg": "./static/icones/linkedin.svg?raw",
	"./loading-setas.svg": "./static/icones/loading-setas.svg?raw",
	"./logo-mindsight.svg": "./static/icones/logo-mindsight.svg?raw",
	"./logo-sankhya.svg": "./static/icones/logo-sankhya.svg?raw",
	"./lupa.svg": "./static/icones/lupa.svg?raw",
	"./mao_pendente.svg": "./static/icones/mao_pendente.svg?raw",
	"./mao_pendente_linha.svg": "./static/icones/mao_pendente_linha.svg?raw",
	"./megafone.svg": "./static/icones/megafone.svg?raw",
	"./ocultar.svg": "./static/icones/ocultar.svg?raw",
	"./pendente.svg": "./static/icones/pendente.svg?raw",
	"./pendente_justificativa.svg": "./static/icones/pendente_justificativa.svg?raw",
	"./pendente_justificativa_linha.svg": "./static/icones/pendente_justificativa_linha.svg?raw",
	"./pessoinha.svg": "./static/icones/pessoinha.svg?raw",
	"./placar.svg": "./static/icones/placar.svg?raw",
	"./planilha.svg": "./static/icones/planilha.svg?raw",
	"./ponto-entrada.svg": "./static/icones/ponto-entrada.svg?raw",
	"./ponto-pausa.svg": "./static/icones/ponto-pausa.svg?raw",
	"./ponto-retorno.svg": "./static/icones/ponto-retorno.svg?raw",
	"./ponto-saida.svg": "./static/icones/ponto-saida.svg?raw",
	"./pontotel-marca.svg": "./static/icones/pontotel-marca.svg?raw",
	"./pontotel-sankhya-logo.svg": "./static/icones/pontotel-sankhya-logo.svg?raw",
	"./praia.svg": "./static/icones/praia.svg?raw",
	"./relatorios-importacoes.svg": "./static/icones/relatorios-importacoes.svg?raw",
	"./relogio.svg": "./static/icones/relogio.svg?raw",
	"./reprovado.svg": "./static/icones/reprovado.svg?raw",
	"./sem-anexo.svg": "./static/icones/sem-anexo.svg?raw",
	"./sem-conexao.svg": "./static/icones/sem-conexao.svg?raw",
	"./solicitacoes.svg": "./static/icones/solicitacoes.svg?raw",
	"./sparkles.svg": "./static/icones/sparkles.svg?raw",
	"./sucesso-preenchido.svg": "./static/icones/sucesso-preenchido.svg?raw",
	"./sucesso.svg": "./static/icones/sucesso.svg?raw",
	"./suspensao.svg": "./static/icones/suspensao.svg?raw",
	"./tesoura.svg": "./static/icones/tesoura.svg?raw",
	"./tiktok.svg": "./static/icones/tiktok.svg?raw",
	"./tornar-visivel.svg": "./static/icones/tornar-visivel.svg?raw",
	"./vencida_de_resposta.svg": "./static/icones/vencida_de_resposta.svg?raw",
	"./vencida_justificativa_linha.svg": "./static/icones/vencida_justificativa_linha.svg?raw",
	"./vencida_resposta_linha.svg": "./static/icones/vencida_resposta_linha.svg?raw",
	"./verificado-preenchido.svg": "./static/icones/verificado-preenchido.svg?raw",
	"./verificado.svg": "./static/icones/verificado.svg?raw",
	"./webfonts/chapado.svg": "./static/icones/webfonts/chapado.svg?raw",
	"./webfonts/linha.svg": "./static/icones/webfonts/linha.svg?raw",
	"./whatsapp.svg": "./static/icones/whatsapp.svg?raw",
	"./youtube.svg": "./static/icones/youtube.svg?raw"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./static/icones sync recursive ^\\.\\/.*\\.svg$";